<script setup lang="ts">
import { useRouteLayout } from '@nsftx/seven-client-retail-vue-common'
import { useAppBootstrap } from '@/composables/useAppBootstrap/useAppBootstrap'

const { isAppReady } = useAppBootstrap()
const { activeLayoutComponent } = useRouteLayout()
</script>

<template>
  <component v-if="isAppReady" :is="activeLayoutComponent">
    <template #main-content>
      <router-view />
    </template>
  </component>
</template>
